var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vsector__counts" }, [
    _c("span", { staticClass: "subheading" }, [_vm._v("In Numbers")]),
    _vm._v(" "),
    _vm.counts
      ? _c("dl", { staticClass: "counts" }, [
          _c("div", { staticClass: "counts__item count" }, [
            _c("dt", [_vm._v("Opportunities")]),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c(
                  "router-link",
                  { attrs: { to: `/opportunities?sectors=${_vm.sectorId}` } },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.counts.opportunities))]),
                    _vm._v(" "),
                    _c(
                      "sup",
                      [
                        _c("SvgIcon", {
                          staticStyle: {
                            width: "1.4rem",
                            height: "1.4rem",
                            "margin-left": "-0.4rem",
                          },
                          attrs: { icon: "ex-link", "is-filled": true },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "counts__item count" }, [
            _c("dt", [_vm._v("MADDs")]),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c(
                  "router-link",
                  { attrs: { to: `/madds?sectors=${_vm.sectorId}` } },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.counts.madds))]),
                    _vm._v(" "),
                    _c(
                      "sup",
                      [
                        _c("SvgIcon", {
                          staticStyle: {
                            width: "1.4rem",
                            height: "1.4rem",
                            "margin-left": "-0.4rem",
                          },
                          attrs: { icon: "ex-link", "is-filled": true },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "counts__item count" }, [
            _c("dt", [_vm._v("Documents")]),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("router-link", { attrs: { to: _vm.documentLink } }, [
                  _c("span", [_vm._v(_vm._s(_vm.counts.insights))]),
                  _vm._v(" "),
                  _c(
                    "sup",
                    [
                      _c("SvgIcon", {
                        staticStyle: {
                          width: "1.4rem",
                          height: "1.4rem",
                          "margin-left": "-0.4rem",
                        },
                        attrs: { icon: "ex-link", "is-filled": true },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "counts__item count" }, [
            _c("dt", [_vm._v("Experts")]),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c(
                  "router-link",
                  { attrs: { to: `/sectors/${_vm.sectorId}/experts` } },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.counts.experts))]),
                    _vm._v(" "),
                    _c(
                      "sup",
                      [
                        _c("SvgIcon", {
                          staticStyle: {
                            width: "1.4rem",
                            height: "1.4rem",
                            "margin-left": "-0.4rem",
                          },
                          attrs: { icon: "ex-link", "is-filled": true },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }